import { useState } from "react";

import "./style.css"

function Gallery({ gallery }) {
    const [counter, setCounter] = useState(0);

    return gallery && (
        <div className='gallery'>
            <div className="view">
                <i style={{ backgroundImage: `url(${gallery[counter].url})` }}></i>
            </div>

            <div className="panel_gallery">
                {gallery.map((img, idx) => (
                    <button
                        key={idx}
                        className="slide"
                        onClick={() => setCounter(idx)}
                    >
                        <i style={{ backgroundImage: `url(${img._url})` }}></i>
                    </button>
                ))}
            </div>
        </div>
    )
}

export default Gallery;